// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-history[data-v-4993f501] {\n  display: inline-block;\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
